<template>
  <div class="overall">
      <iframe crossOrigin="anonymous" id="previewPdf" :src="url"></iframe>
  </div>
</template>

<script>
export default {
data(){
    return{
        url:''
    }
},
created(){
  if(this.$route.query.index==1){
    this.url='/static/pdf/web/viewer.html?file='+this.$route.query.url
  }else{
    this.url='/static/pdf/web2/viewer.html?file='+this.$route.query.url
  }
}
}
</script>

<style lang="scss" scoped>
.overall{
    width: 100%;
    height: 1000px;
    iframe{
      width: 100%;
      height: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/view/index.vue